/* global numeral, infoPageAmCharts, infoConfig*/
if (typeof am4core !== 'undefined') {
    var infoPageHelper = {

        /**
         * Get the allTime total views for a page from the data
         * @param {array} analyticsData Daily analytical data
         * @returns {number} The total views for the page
         */
        getTotalViews: function (analyticsData) {
            // check that there is views data
            var views = 0;
            // calculate total views
            analyticsData.forEach(function (data) {
                views += data.views;
            });
            return views;
        },

        /**
         * Updates date range for the pie chart
         * @param {string} startDate The start date of the line chart
         * @param {string} endDate The end date of the line chart
         * @returns {void}
         */
        updateDateRange: function (startDate, endDate) {
            if (this.isFrench()) {
                startDate = this.updateFirstDayFrench(startDate, true);
                endDate = this.updateFirstDayFrench(endDate, true);
            }
            jQuery("#bocss-info__startDate").html(startDate);
            jQuery("#bocss-info__endDate").html(endDate);
        },

        /**
         * See if it's the first of the month. If so, add <sup>er<sup>
         * @param {string} date the date to be updated
         * @param {boolean} html if the characters should be html
         * @returns {string} formatted date with er sup
         */
        updateFirstDayFrench: function (date, html) {
            var start = "[baseline-shift: super; font-size: 10;]";
            var end = "[/b]";
            if (html) {
                start = "<sup>";
                end = "</sup>";
            }

            if (date.charAt(0) === "1" && date.charAt(1) === " ") {
                date = "1" + start + "er" + end + " " + date.substring(1);
            }
            return date;
        },

        /**
         * Updates total views within chart range
         * @param {integer} views Number of views between start and end date on line chart
         * @returns {void}
         */
        updateRangeViews: function (views) {
            views = Math.round(views);
            var format = '0.[0]a';
            var suffix = '';

            //if it's in the 100k's, we need space so remove the decimal
            if (views >= 100000 && views < 1000000) {
                format = '0a';
            }
            var formattedViews = numeral(views).format(format);

            // apply additional formatting for french
            if (infoPageHelper.isFrench()) {
                var prefix = '';
                if (views >= 1000) {
                    //remove the abbreviation
                    formattedViews = formattedViews.slice(0, -1);
                    prefix = "<b>mille</b> ";
                }

                if (views >= 1000000) {
                    // check if 'million(s)' should be plural
                    var val = views.toString().substr(0, 1);
                    var plural = val > 1 ? 's' : '';
                    prefix = "<b>million" + plural + "</b> de ";
                }

                prefix = prefix + infoConfig.labelsFr['viewsChart']['textViews'];
                jQuery("#bocss-info__rangeViewsDescriptor").html(prefix);

                // Apply additional formatting for english
            } else if (views >= 1000) {
                suffix = '<span>' + formattedViews.slice(-1).toString() + '</span>';
                formattedViews = formattedViews.slice(0, -1);
            }

            jQuery("#bocss-info__rangeViews").text(formattedViews);
            if (suffix !== '') {
                suffix = jQuery("#bocss-info__rangeViews").html() + suffix;
                jQuery("#bocss-info__rangeViews").html(suffix);
            }
        },

        /**
         * Return if the current page is in French
         * @returns {boolean} True if the page is in French, else false
         */
        isFrench: function () {
            return document.documentElement.lang === 'fr-FR';
        },

        /**
         * Checks to see if the theme is in dark mode
         * @returns {boolean} is it dark?
         */
        isDarkTheme: function () {
            return document.documentElement.getAttribute('data-theme') === 'dark';
        },

        /**
         * Resizes the legend height based on current content height
         * @returns {void} void
         */
        resizeLegend: function () {
            document.getElementById("bocss-info__deviceLegend").style.height =
                infoPageAmCharts.deviceChart.legend.contentHeight + "px";
        },

        /**
         * Return properly formatted date
         * @param {string} dateString The date to be formatted
         * @returns {string} Formatted date
         */
        formatDate: function (dateString) {
            var date = new Date(dateString),
                month = date.getMonth() + 1,
                day = date.getDate(),
                year = date.getFullYear();

            if (month < 10) {
                month = '0' + month;
            }
            if (day < 10) {
                day = '0' + day;
            }
            return [year, month, day].join('/');
        },

        /**
         * Returns the week starting from the date
         * @param {string} dateString Initial date of the week
         * @returns {string} Date for the end of the week
         */
        getWeek: function (dateString) {
            var weekStart = new Date(dateString);
            var weekEnd = weekStart;
            weekEnd.setDate(weekStart.getDate() + 6);
            return this.formatDate(weekEnd);
        }
    };
}
